import { cacheDom } from '../utils/QuerySelectors.js'
import Fuse from 'fuse.js'

const dom = {}
const qs = {
  popup: 'data-popup',
  search: 'data-country-search',
  input: 'data-current-country-value',
  form: 'data-country-form',
}
const qsAll = {
  triggers: 'data-geo-country-selector',
  buttons: 'data-country-value',
}
const state = {
  inputTimer: null,
}

const initEvents = () => {
  const form = dom.popup.querySelector(`[${qs.form}]`)
  const input = dom.popup.querySelector(`[${qs.input}]`)
  const searchBox = dom.popup.querySelector(`[${qs.search}]`)
  const buttons = dom.popup.querySelectorAll(`[${qsAll.buttons}]`)
  const details = dom.popup.querySelectorAll('details')
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      if(!button.classList.contains('bg-sixth-grey')) {
        const country = button.getAttribute(qsAll.buttons)
        input.value = country
        form.submit()
      }
    })
  })
  searchBox.addEventListener('input', () => {
    clearTimeout(state.inputTimer)
    state.inputTimer = setTimeout(() => {
      details.forEach(detail => detail.removeAttribute('open'))
      if(searchBox.value.trim() != '') {
        let fuse = new Fuse(window.availableCountries, {
          includeScore: true,
          keys: [
            {
              name: 'name',
              weight: 1,
            },
            {
              name: 'code',
              weight: 1,
            },
          ],
          // useExtendedSearch: true,
        })
        const results = fuse.search(searchBox.value)
        console.log('results', results)
        buttons.forEach(button => {
          const isoCode = button.getAttribute(qsAll.buttons)
          button.classList.toggle('!hidden', results.filter(r => r.item.code == isoCode && r.score < 0.2).length == 0)
          if(!button.classList.contains('!hidden')) {
            button.closest('details').setAttribute('open', '')
          }
        })
      } else {
        buttons.forEach(button => button.classList.remove('!hidden'))
      }
    }, 300)
  })
}

export const setupCountryPop = () => {
  cacheDom(dom, qs, qsAll)
  
  dom.triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      window.openPopup(document.querySelector('#countryPopup').innerHTML)
      initEvents()
    })
  })
}
